// extracted by mini-css-extract-plugin
module.exports = {"social":"Connect_social__yR5yd","sitelogo":"Connect_sitelogo__M2Hc1","image":"Connect_image__5aQ0y","socialitem":"Connect_socialitem__8Bca_","link":"Connect_link__N3gQj"};